import React from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { HomePageEvent } from 'store/events/types';
import EventCard from '../EventCard';
import HomePageCardSkeleton from '../Skeletons/HomePage/HomePageCardSkeleton';

interface VendorEventsListingProps {
  events: HomePageEvent[] | undefined;
  remainingEvents: number;
  loadMoreEvents: () => void;
  isFetching: boolean;
}

const VendorEventsListing: React.FC<VendorEventsListingProps> = ({
  events,
  loadMoreEvents,
  remainingEvents,
  isFetching,
}) => {
  const { t } = useTranslation();

  if (!events || !events.length) {
    return (
      <p className="p1-medium">
        {t('vendorEventsPage.thereAreNotAvailableEvents')}
      </p>
    );
  }

  return (
    <InfiniteScroll
      pageStart={1}
      loadMore={loadMoreEvents}
      hasMore={remainingEvents > 0}
      threshold={120}
    >
      <div className="grid gap-[24px] grid-cols-1 min-[700px]:grid-cols-2 min-[1024px]:grid-cols-3 min-[1380px]:grid-cols-4">
        {events.map(event => (
          <div
            key={event.id}
            className="w-full min-w-[290px] max-w-[350px] mx-auto bg-neutral-0 shadow-[0_4px_26px_rgba(0,0,0,0.02)]"
          >
            <EventCard event={event} />
          </div>
        ))}
        {isFetching
          ? new Array(Math.min(remainingEvents, 4))
              .fill(undefined)
              .map((_, index) => index + 1)
              .map(id => <HomePageCardSkeleton key={id} />)
          : null}
      </div>
    </InfiniteScroll>
  );
};

export default VendorEventsListing;
